import React from 'react'
import Text from '../../components/text/Text'
import WizButton from '../../components/button/WizButton'
import ContentBlocksInlinePreview from './ContentBlocksInlinePreview'
import {AI_FEED_CATEGORY_LABEL} from './constants'
import {IFeedItem} from './types'

interface IProps {
    item: IFeedItem | null
    onConfirm: () => void
    onCancel: () => void
}

// 노출(활성/비활성) 토글 확인 모달. 대상의 현재 상태(active)에 따라 반대 동작을 묻는다.
const ConfirmActiveModal: React.FC<IProps> = ({item, onConfirm, onCancel}) => {
    if (!item) return null
    const activating = item.active === false // 현재 비활성 → 활성화
    const title = activating ? '활성화하시겠습니까?' : '비활성화하시겠습니까?'

    return (
        <div className={'fixed inset-0 z-modal flex items-center justify-center'}>
            <div className={'absolute inset-0 bg-black/50'} onClick={onCancel} />
            <div className={'relative z-10 w-[90%] max-w-[480px] bg-white rounded-[8px] p-[24px] shadow-hover'}>
                <Text className={'text-h3 text-font01'}>{title}</Text>
                <Text className={'text-ti3 text-font03 mt-[6px]'}>
                    {item.category ? AI_FEED_CATEGORY_LABEL[item.category] : ''}
                    {activating ? '' : ' · 비활성 템플릿은 발행 시 선택되지 않습니다.'}
                </Text>

                {/* 활성화는 무엇을 켜는지 확인용으로 미리보기 표시. 비활성화는 미리보기 없이 확인만. */}
                {activating && (
                    <div
                        className={
                            'mt-[16px] border border-line02 rounded-[8px] px-[16px] py-[12px] bg-line04 text-body2 leading-[1.8]'
                        }>
                        <ContentBlocksInlinePreview blocks={item.content_blocks} />
                    </div>
                )}

                <div className={'mt-[24px] flex items-center justify-end gap-x-[10px]'}>
                    <WizButton text={'취소'} type={'cancel'} onClick={onCancel} />
                    <WizButton
                        text={activating ? '활성화' : '비활성화'}
                        type={activating ? 'primary' : 'black'}
                        onClick={onConfirm}
                    />
                </div>
            </div>
        </div>
    )
}

export default ConfirmActiveModal
